interface RecoveryCallbackLocation {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
}

export function resolvePaxRecoveryCallbackPath({
  hostname,
  pathname,
  search,
  hash,
}: RecoveryCallbackLocation): string | null {
  if (!hostname.startsWith("pax.") || pathname !== "/") return null;

  const params = new URLSearchParams(hash.replace(/^#/, ""));
  const errorCode = params.get("error_code");
  const description = params.get("error_description") || "";
  const isRecoveryCallback =
    params.get("type") === "recovery" ||
    errorCode === "otp_expired" ||
    /password(?:%20|\s|\+)*reset|recovery/i.test(description);

  if (!isRecoveryCallback) return null;

  // Preserve valid tokens or Supabase's allowlisted error fields until the
  // reset screen has rendered the correct state and removed them from history.
  return `/reset-password${search}${hash}`;
}
